// Shared venue image configuration
export const FACILITY_IMAGES = {
  facility_trp_sports: '/venues/trp_sports.webp',
  facility_picknpadel: '/venues/picknpadel.webp',
  facility_ferrohub: '/venues/ferrohub.webp',
  facility_ferrohub_budigere: '/venues/ferrohub_budigere.webp',
  facility_depot18: '/venues/depot18.webp',
  facility_sportsweb: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800&q=80',
};

export const SPORT_LABELS = {
  football: 'Football',
  padel: 'Padel',
  pickleball: 'Pickleball',
  pickle: 'Pickleball',
  cricket: 'Cricket',
  snooker: 'Snooker',
};

export const SPORT_ICONS = {
  football: '⚽',
  padel: '🎾',
  pickleball: '🏓',
  pickle: '🏓',
  cricket: '🏏',
  snooker: '🎱',
};

export const FACILITY_MAPS = {
  facility_trp_sports: 'https://maps.app.goo.gl/Tw3wufejaABZAe7W9',
  facility_depot18: 'https://maps.app.goo.gl/M1PRgwtApr6U4CW47',
  facility_ferrohub: 'https://maps.app.goo.gl/vphZ8TX18a6uVZN47',
  facility_ferrohub_budigere: 'https://maps.app.goo.gl/djYDB2VY2RNXYzre6',
  facility_picknpadel: 'https://maps.app.goo.gl/jWyPvtv3ZucoGjEM7',
  facility_sportsweb: 'https://maps.app.goo.gl/u3XD4efDSAvs99r99',
};

export const VENUE_SLUG_TO_FACILITY = {
  'sufc': 'facility_trp_sports',
  'depot18': 'facility_depot18',
  'ferrohub': 'facility_ferrohub',
  'ferrohub-budigere': 'facility_ferrohub_budigere',
  'picknpadel': 'facility_picknpadel',
  'sportsweb': 'facility_sportsweb',
};

export const getFacilityMapUrl = (facilityId) => FACILITY_MAPS[facilityId] || '';
export const getMapUrlBySlug = (slug) => FACILITY_MAPS[VENUE_SLUG_TO_FACILITY[slug] || ''] || '';

export const DEFAULT_VENUE_IMAGE = 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800&q=80';

export const getFacilityImage = (facilityId) => FACILITY_IMAGES[facilityId] || DEFAULT_VENUE_IMAGE;

// Small ~240px thumbnail for list rows (Book page). Local venues have a /venues/thumbs/ variant.
export const getFacilityThumb = (facilityId) => {
  const full = FACILITY_IMAGES[facilityId];
  if (full && full.startsWith('/venues/')) return full.replace('/venues/', '/venues/thumbs/');
  const remote = full || DEFAULT_VENUE_IMAGE;
  return /w=\d+/.test(remote) ? remote.replace(/w=\d+/, 'w=240') : `${remote}${remote.includes('?') ? '&' : '?'}w=240`;
};

export const normalizeSport = (sport) => sport === 'pickle' ? 'pickleball' : sport;
